<template>
<div class="chapter">
<div class="inner_page">
<p class="center" id="note"><span><b><i>Author’s Note</i></b></span></p>
<blockquote>
<p class="noind"><span>It may be interesting to note that U-boats were referred to by both captains and crews as “Iron Coffins.” Rightly so; 736 German submarine crews still lie with their boats on the ocean floor.</span></p>
<p class="right"><span>R.R.M.</span></p>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 3-note.vue?d6003a42